import { Box, UnorderedList } from "@chakra-ui/react";
import { useEffect, useState } from "react";

import BankAccountRow from "./BankAccountRow";
import CreatePlaidTokenButton from "./CreatePlaidTokenButton";
import RefreshBalancesButton from "./RefreshBalancesButton";
import { apiRequest } from "utils/api";
import { useTenant } from "modules/tenant/providers/tenant-provider";

const PlaidConnect = () => {
  const { user } = useTenant();
  const [accounts, setAccounts] = useState([]);

  const selectBankAccounts = async () => {
    try {
      const { bank_accounts } = await apiRequest("/supabase/bank_accounts/select");
      setAccounts(bank_accounts);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    selectBankAccounts();
  }, []);

  return (
    <Box>
      <UnorderedList listStyleType="none" p="0px" m="0px">
        {accounts.map((account: any) => (
          <BankAccountRow key={account.id} account={account} />
        ))}
      </UnorderedList>
      <Box w="100%">
        {user.plaid_tokens.length > 0 && <RefreshBalancesButton />}
        <CreatePlaidTokenButton accounts={accounts} />
      </Box>
    </Box>
  );
};

export default PlaidConnect;
